import React from 'react';

export type SwitchProps = {
  a11yLabel: string;
  active: boolean;
  onToggle: React.ChangeEventHandler;
  className?: string;
  activeLabel?: string;
  inactiveLabel?: string;
};

function Switch({
  className = '',
  activeLabel,
  inactiveLabel,
  a11yLabel,
  active,
  onToggle,
}: SwitchProps) {
  return (
    <div className={`switch ${className}`}>
      {inactiveLabel && (
        <div className="switch__label switch__label--inactiveLabel">{inactiveLabel}</div>
      )}
      <label className={`switch__toggle ${active ? 'switch__toggle--on' : ''}`}>
        <span className="screen-reader-text">Toggle {a11yLabel}</span>
        <input
          type="checkbox"
          className="screen-reader-text"
          onChange={onToggle}
          checked={active}
        />
      </label>
      {activeLabel && <div className="switch__label switch__label--activeLabel">{activeLabel}</div>}
    </div>
  );
}

export default Switch;
